export const initialState = {
  userList: [],
  userPendingList: [],
  form: false,
  userUid: null,
  profiles: [],
  searchString: null,
};
